import { createSlice } from '@reduxjs/toolkit';
import { MEDIA_STORE_NAME } from '../constants';

const initialState = {
    imagesList: [],
    isEndPage: false,
    uploadingImages: false,
    storageUsage: null,
};

export const media = createSlice({
    name: MEDIA_STORE_NAME,
    initialState,
    reducers: {
        unshiftImages: (state, action) => {
            state.imagesList = [...action.payload, ...state.imagesList];
        },
        setImages: (state, action) => {
            state.imagesList = action.payload;
        },
        setIsEndPage: (state, action) => {
            state.isEndPage = action.payload;
        },
        toggleUploadingImages: (state) => {
            state.uploadingImages = !state.uploadingImages;
        },
        clearImagesList: (state) => {
            state.imagesList = [];
        },
        setStorageUsage: (state, action) => {
            state.storageUsage = action.payload;
        },
    },
});

export const { setImages, clearImagesList, unshiftImages, toggleUploadingImages, setIsEndPage, setStorageUsage } =
    media.actions;
export default media.reducer;
